import { Container, CustomImage } from 'components/shared';
import styles from './Encryption.module.css';

export const EncryptionSection = () => {
  const icons = [
    { src: 'hipaa-1.png', alt: 'hipaa' },
    { src: 'iso-1.png', alt: 'iso' },
    { src: 'gdpr-1.png', alt: 'iso' },
    { src: 'ce-1.png', alt: 'iso' },
  ];
  return (
    <div className={styles.encryptionSectionContainer}>
      <Container>
        <h3>Your data is secure, private, and always under your control.</h3>
        <div className={styles.imgContainer}>
          {icons.map((icon, index) => (
            <CustomImage
              key={`icon-${index}`}
              src={`web_v2/womens-health/encryption/${icon.src}`}
              width={124}
              height={124}
              alt={icon.alt}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};
